import {
    Box,
    Button,
    Container,
    Divider,
    Grid,
    Typography,
} from "@material-ui/core";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import StoryCardSmall, { Story } from "../StoryCardSmall/StoryCardSmall";
import config from "../../config/apiConfig";
import Loader from "react-spinners/RingLoader";
import { KeyboardArrowLeft } from "@material-ui/icons";
import { RouteComponentProps } from "react-router";

const TopCritics: React.FC<RouteComponentProps> = ({ history }) => {
    const [stories, setStories] = useState<Story[]>([]);
    const [page, setPage] = useState(1);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        fetch(
            config.BASE_URL +
                "/v2/api/story/getAll?page=" +
                page +
                "&pageSize=48&orderBy=2",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => {
                setStories([...stories, ...res]);
                if (res.length < 48) {
                    setCanLoadMore(false);
                }
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
    }, [page]);

    return (
        <React.Fragment>
            <Navbar />
            <Box height={100} component="div" />
            <Container maxWidth="lg">
                <Button
                    size="small"
                    style={{ textTransform: "none", fontWeight: "bold" }}
                    onClick={() => history.goBack()}
                >
                    <KeyboardArrowLeft />
                    <span>Go Back</span>
                </Button>
                <Typography variant="h3">From Top Critics</Typography>
                <Divider style={{ margin: "32px 0" }} />
                <Grid container justify="center" spacing={2}>
                    {stories.map((s) => (
                        <Grid item key={s.storyId}>
                            <StoryCardSmall
                                onRemove={() =>
                                    setStories(stories.filter((t) => t !== s))
                                }
                                {...s}
                            />
                        </Grid>
                    ))}
                    {canLoadMore && !loading && (
                        <Grid
                            item
                            xs={12}
                            style={{ textAlign: "center", marginBottom: 32 }}
                        >
                            <Button onClick={() => setPage(page + 1)}>
                                Show More
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </Container>
            {loading && <Loader color="var(--primary-color)" />}
        </React.Fragment>
    );
};

export default TopCritics;
